module.exports = __webpack_public_path__ + "src/assets/img/bg1.b4575e01.png";